module.exports = __webpack_public_path__ + "static/media/key.95405a81.svg";